import { ShopCore } from "@/abilities/shop/types/shop-core";
import { safeJoinURL } from "@/shared/utils/route-utils";
import { ApolloClient, InMemoryCache, NormalizedCacheObject, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

export function createShopApolloClient(
    graphUrl: string,
    options: {
        accessToken?: string;
        healthCheckOnly?: boolean;
        additionalHeaders?: Record<string, string | undefined>;
    } = {
        healthCheckOnly: false,
        additionalHeaders: {},
    }
): ShopCore.ClientWithCache {
    const cache = new InMemoryCache();
    const { accessToken, healthCheckOnly, additionalHeaders } = options;

    const authLink = setContext((_, { headers }) => {
        return {
            headers: {
                ...headers,
                authorization: healthCheckOnly ? undefined : accessToken ? `Bearer ${accessToken}` : "",
                ...additionalHeaders,
            },
        };
    });

    const httpLink = createHttpLink({
        uri: safeJoinURL(graphUrl, "graphql").href,
        fetch,
    });

    const client = new ApolloClient<NormalizedCacheObject>({
        link: healthCheckOnly ? httpLink : authLink.concat(httpLink),
        cache: cache,
    });

    return {
        client,
        cache,
    };
}
